module.exports = __webpack_public_path__ + "static/media/BlackStar13_3_t.dd923fdb.jpg";